/**
 @Developper: BenAli Faker
 @Company: SMART-INFO
 @Post: CTO
 @Date:20/02/2022
 @Time:11:32
 **/
import SocieteUI from "../backend/societe/web/SocieteUI";
$(function(){
    //we are in register page
   if($("#register").length>0)
   {
       Begro.logInfo("La page register est est détecté!");
       $('#link-agree-to-the-terms').click(function(){
           Begro.logInfo("Le lien conditions d'utilisation est cliqué");
           $("#agree-to-the-terms-checkbox").removeAttr("disabled");
       });
       $("#agree-to-the-terms-checkbox").change(function(){
           Begro.logInfo("Le choix `accepter conditions d'utilisation` est changé");
           if($(this).is(":checked"))
           {
             $("#register-button").removeAttr("disabled");
           }else{
              $("#register-button").attr("disabled","disabled");
           }
       });
       //attachement identifiant fiscal input mask
       SocieteUI.attacherInputMaskToIdentifiantFiscal();
   }
});